import React, { useEffect } from 'react';
import './TermsPrivacy.scss';

const tg = window.Telegram.WebApp;

const Privacy = () => {
    useEffect(() => {
        tg.BackButton.show();
        tg.BackButton.onClick(() => {
            tg.BackButton.hide();
            window.history.back();
        });

        return () => {
            tg.BackButton.hide();
            tg.BackButton.offClick();
        };
    }, []);

    return (
        <div className="termsPrivacy">
            <h1>Deadline ML – Privacy Policy</h1>
            <p>Your privacy is important to us. This Privacy Policy describes how <strong>Deadline ML</strong>, a Telegram mini-app, collects, uses, and protects your data.</p>

            <div className="termsPrivacy__content">
                <h2>Information We Collect</h2>
                <p>We collect the following types of data:</p>
                <ul>
                    <li><strong>Basic Profile Data:</strong> Information you provide when using the app (e.g., Telegram ID, username).</li>
                    <li><strong>Usage Data:</strong> Interaction logs and engagement statistics to improve our services.</li>
                    <li><strong>AI Processing Data:</strong> Inputs related to lifespan estimations and recommendations.</li>
                </ul>
                <p>We do not collect sensitive personal data, such as health records or biometric information.</p>

                <h2>How We Use Your Data</h2>
                <p>Your data is used to:</p>
                <ul style={{ listStyleType: 'decimal' }}>
                    <li>Provide AI-generated lifespan estimations.</li>
                    <li>Offer personalized suggestions (for Full-access users).</li>
                    <li>Improve app functionality and user experience.</li>
                </ul>

                <h2>Data Sharing</h2>
                <p>We do not sell or share personal data with third parties. Data is only processed internally to enhance app services.</p>

                <h2>Cookies and Tracking</h2>
                <p><strong>Deadline ML</strong> does not use cookies or external tracking tools. However, Telegram may collect analytical data as per its policies.</p>

                <h2>Data Security</h2>
                <p>We implement security measures to protect your information. However, no online service is completely secure, and users should take precautions while sharing data.</p>

                <h2>User Rights</h2>
                <p>You have the right to:</p>
                <ul>
                    <li>Access the data we collect.</li>
                    <li>Request data deletion via in-app support.</li>
                    <li>Opt-out of non-essential data collection.</li>
                </ul>

                <h2>Changes to This Policy</h2>
                <p>We may update this Privacy Policy periodically. Continued use of Deadline ML after changes implies acceptance of the revised policy:</p>

                <h2>Contact Information</h2>
                <p>For inquiries, please reach out via official <strong>Deadline ML</strong> Telegram group: t.me/deadlineml.</p>
            </div>
        </div>
    );
};

export default Privacy;
